__webpack_require__.p = "/wp-content/themes/branding-therapy/assets/";